import { Box, BoxProps, Typography, styled } from '@mui/material';
import React, { FC, PropsWithChildren } from 'react';

import { CARD_HEIGHT, CARD_WIDTH } from '../deck-card';
import { BhabiLogo } from '../../../../../assets';
import { blueGrey, grey } from '@mui/material/colors';

export { Thoka, THOKA_DURATION_S, THOKA_FEEDBACK } from './thoka';

export const LogoCard: FC<PropsWithChildren<BoxProps>> = ({
  children,
  ...props
}) => {
  return (
    <Box
      {...{
        height: CARD_HEIGHT,
        width: CARD_WIDTH,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        bgcolor: theme =>
          theme.palette.mode === 'dark' ? blueGrey[900] : grey[500],
        boxShadow: theme => theme.shadows[6],
        sx: {
          borderRadius: '8px',
        },
        ...props,
      }}
    >
      <BhabiLogo
        style={{
          width: 50,
          height: 50,
        }}
      />
      {children}
    </Box>
  );
};

export interface ConcludedCardsDeckProps {
  concludedCards: number;
}

export const ConcludedCardsDeck: FC<ConcludedCardsDeckProps> = ({
  concludedCards,
}) => {
  return (
    <LogoCard>
      <Typography
        fontSize={{
          lg: '2rem',
          sm: '1.5rem',
        }}
        fontWeight={700}
        sx={{ color: theme => theme.palette.success.dark }}
      >
        {concludedCards}
      </Typography>
    </LogoCard>
  );
};

interface PlayerAvatarWrapperProps {
  isHorizontal?: boolean;
}
export const PlayersAvatarWrapper = styled(Box, {
  shouldForwardProp: props => props !== 'isHorizontal',
})<PlayerAvatarWrapperProps>(({ isHorizontal, theme }) => ({
  ...(isHorizontal
    ? {
        display: 'flex',
        width: '100%',
        flexWrap: 'wrap',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        gap: theme.spacing(1),
        overflow: 'hidden',
        paddingTop: theme.spacing(2),
      }
    : {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: theme.spacing(3),
      }),
}));

export const PlaygroundWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  height: `calc(100vh - ${CARD_HEIGHT})`,
  padding: theme.spacing(0.5, 2),
  paddingTop: theme.spacing(2),
}));

export interface InPlayCardsWrapperProps {
  gridWidth: number;
  numberOfPlayers: number;
}

export const InPlayCardsWrapper = styled(Box, {
  shouldForwardProp: props =>
    props !== 'gridWidth' && props !== 'numberOfPlayers',
})<InPlayCardsWrapperProps>(({ theme, gridWidth, numberOfPlayers }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  width: '100%',
  '& .inner_box': {
    position: 'relative',
    width: '80%',
    margin: '0 auto',
    display: 'grid',
    gridTemplateColumns: `repeat(${numberOfPlayers}, ${gridWidth}px)`,
    gap: theme.spacing(0.5),
  },
}));

export const BottomLeftBox = styled(Box)<{ isVerticalMode: boolean }>(
  ({ theme, isVerticalMode }) => ({
    position: 'absolute',
    bottom: `calc(${isVerticalMode ? 120 : 20}px + env(safe-area-inset-bottom))`,
    left: theme.spacing(2),
    zIndex: 2300,
  })
);
